import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the #root container to top on every route change.
 * Fixes the back-navigation page-drop issue on iOS where scroll position
 * persists across navigations in a container with overflow-y: auto.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.scrollTop = 0;
    }
    // Also try window scroll for good measure
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
